import { render } from "./EmployeeCreate.vue?vue&type=template&id=1bd657d8&scoped=true"
import script from "./EmployeeCreate.vue?vue&type=script&lang=ts"
export * from "./EmployeeCreate.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1bd657d8"

export default script